<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          KEY HIGHLIGHT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Message' : 'Create New Message' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData()" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="confirmSubmit" class="py-5 px-4">
            <v-layout row wrap>
              <v-flex xs6 class="py-0">
                <label class="darkblue--text"> Start Date </label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.start"
                      outlined
                      placeholder="Start Date"
                      prepend-inner-icon="event"
                      single-line
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.start"
                    no-title
                    scrollable
                    :min="minDate"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 class="py-0">
                <label class="darkblue--text"> End Date </label>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="item.end"
                      outlined
                      placeholder="End Date"
                      prepend-inner-icon="event"
                      single-line
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="item.end"
                    no-title
                    scrollable
                    @input="menu2 = false"
                    :min="minDate"
                  ></v-date-picker>
                </v-menu>
                <span
                  v-if="validationMessage != ''"
                  class="red--text caption"
                  >{{ validationMessage }}</span
                >
              </v-flex>
              <v-flex xs12 class="py-0">
                <ValidationProvider
                  name="Message"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Message</label>
                  <v-text-field
                    id="message"
                    single-line
                    outlined
                    dense
                    label="Message"
                    :rules="rules"
                    counter
                    maxlength="30"
                    v-model="item.message"
                    required
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs12 class="py-0">
                <ValidationProvider
                  name="Receiver"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-checkbox
                    name="Receiver"
                    v-model="useProfile"
                    label="Send to specific profile?"
                    color="primary"
                    :error-messages="errors"
                  ></v-checkbox>
                </ValidationProvider>
              </v-flex>
              <v-flex xs12 class="py-0" v-if="useProfile">
                <ValidationProvider
                  name="Profile"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Receiver</label>
                  <v-autocomplete
                    autocomplete
                    v-model="item.profilesChecklist"
                    :items="profiles"
                    dense
                    label="Select Profile"
                    multiple
                    single-line
                    outlined
                    item-text="desc"
                    return-object
                    :error-messages="errors"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              item.positionsChecklist.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs12 class="py-0" v-else>
                <ValidationProvider
                  name="Receiver"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label class="darkblue--text">Receiver</label>
                  <v-autocomplete
                    autocomplete
                    id="Receiver"
                    multiple
                    single-line
                    outlined
                    dense
                    label="Select Receiver"
                    v-model="item.positionsChecklist"
                    required
                    :items="positions"
                    item-value="id"
                    item-text="position"
                    :error-messages="errors"
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="
                              item.positionsChecklist.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                          >
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Select All </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-autocomplete>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right pr-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'keyHighlight' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="confirmSubmit()"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import moment from 'moment';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      loading: true,
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'Key Highlight',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Message List',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.id ? 'Edit Message' : 'Create New Message',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      rules: [v => v.length <= 25 || 'Max 30 characters'],
      minDate: new Date().toISOString().slice(0, 10),
      profiles: [],
      positions: [],
      item: {
        start: '',
        end: '',
        profilesChecklist: [],
        positionsChecklist: [],
        message: ''
      },
      menu: false,
      menu2: false,
      validationMessage: '',
      useProfile: false
    };
  },
  async mounted() {
    await this.getData();
  },
  watch: {
    useProfile(val) {
      if (val) {
        this.item.positionsChecklist = [];
      } else {
        this.item.profilesChecklist = [];
      }
    }
  },
  computed: {
    AllPosition() {
      if (this.useProfile) {
        return this.item.profilesChecklist.length === this.profiles.length;
      } else {
        return this.item.positionsChecklist.length === this.positions.length;
      }
    },
    SomePosition() {
      if (this.useProfile) {
        return this.item.profilesChecklist.length > 0 && !this.AllPosition;
      } else {
        return this.item.positionsChecklist.length > 0 && !this.AllPosition;
      }
    },
    icon() {
      if (this.AllPosition) return 'mdi-close-box';
      if (this.SomePosition) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.AllPosition) {
          this.item.profilesChecklist = [];
          this.item.positionsChecklist = [];
        } else {
          if (this.useProfile) {
            this.item.profilesChecklist = this.profiles.slice();
          } else {
            this.item.positionsChecklist = this.positions
              .map(val => {
                return val.id;
              })
              .slice();
          }
        }
      });
    },
    async getData() {
      await this.getPosition();
      await this.getProfile();
      if (this.id) {
        await this.getDetail();
      }
    },
    getPosition() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('position/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.positions = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getProfile() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('profile/getAll', {
          paginate: false
        })
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.profiles = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      return this.$store
        .dispatch('keyHighlight/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            let profilesChecklist = [];
            let positionsChecklist = [];
            if (data.data.type.toLowerCase() === 'profiles') {
              profilesChecklist = data.data.profilesChecklist;
            } else {
              positionsChecklist = data.data.positionsChecklist.map(item => {
                return item.id;
              });
            }
            this.item = {
              start: moment(data.data.start).format('YYYY-MM-DD'),
              end: moment(data.data.end).format('YYYY-MM-DD'),
              profilesChecklist: profilesChecklist,
              positionsChecklist: positionsChecklist,
              message: data.data.message
            };
            this.useProfile =
              data.data.type.toLowerCase() === 'profiles' ? true : false;
            if (this.item.start === 'Invalid date') {
              this.item.start = '';
            }
            if (this.item.end === 'Invalid date') {
              this.item.end = '';
            }
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    clear() {
      this.item = {
        start: '',
        end: '',
        profilesChecklist: [],
        positionsChecklist: [],
        message: ''
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    confirmSubmit() {
      let text = '';
      if (this.id) {
        text = 'Are you sure want to edit this message?';
      } else {
        text = 'Are you sure want to save this message?';
      }
      Swal.fire({
        title: '',
        text: text,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a0f6',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'Cancel'
      }).then(result => {
        if (result.value) {
          this.save();
        }
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        if (this.useProfile) {
          this.item.positionsChecklist = [];
        } else {
          this.item.profilesChecklist = [];
        }
        let profile_id = localStorage.getItem('profile_id');
        this.item.profilesChecklist = this.item.profilesChecklist.map(item => {
          return item.id;
        });
        let body = {
          ...this.item,
          usePosition: !this.useProfile,
          profile_id: Number(profile_id)
        };
        if (this.id) {
          this.$store
            .dispatch('keyHighlight/update', { id: this.id, params: body })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'keyHighlight'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('keyHighlight/create', body)
            .then(data => {
              this.progressDialogLoading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'keyHighlight'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>
